// Alarm close decisions (every alarm ends with a recorded decision: cause +
// corrective action + product decision, signed). Stored as tenant app
// records (APP_GUIDE: app state via /records, app "coldchain") on the
// alarm's device until the platform closes alarms itself (GIOTHUB CR).
import { tenantApi } from "../lib/account";

export interface CloseBody { alarm_id: string; alarm_type: string; cause: string; action: string; probe: string; product: string; record: string; meaning: string; signer: string }
export interface CloseRecord { id: string; device_id: string | null; occurred_at: string; author_name: string; body: CloseBody }

export async function loadCloses(fromIso: string): Promise<Map<string, CloseRecord>> {
  const r = await tenantApi<{ items: CloseRecord[] }>("GET", `/records?app=coldchain&kind=alarm_close&from=${encodeURIComponent(fromIso)}&limit=500`);
  return new Map(r.items.map((x) => [x.body.alarm_id, x]));
}

export function saveClose(deviceId: string, title: string, body: CloseBody) {
  return tenantApi<CloseRecord>("POST", "/records", { app: "coldchain", kind: "alarm_close", device_id: deviceId, status: "closed", title, body });
}
